import { useState, useEffect } from 'react';
var id = 0;

var genId = function genId() {
  return ++id;
};
/**
 * Generate a unique id for a component.
 * Useful for accessibility controls (htmlFor, describedBy)
 */


export var useUid = function useUid(id) {
  var _a = useState(id || ''),
      generatedId = _a[0],
      setGeneratedId = _a[1];

  useEffect(function () {
    return setGeneratedId(id || genId().toString());
  }, [id]);
  return generatedId;
};